module Meevo.Plugins.Sandbox {
    import Sandbox = Meevo.Model.ISandbox;
    import SandboxProcessQueue = Meevo.Model.ISandboxProcessQueue;
    import SandboxRequestStatusEnum = Meevo.Model.SandboxProcessStatusEnum;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import SandboxStatusEnum = Meevo.Model.SandboxStatusEnum;
    import ProcessTypeEnum = Meevo.Model.ProcessTypeEnum;

    class SandboxController {
        showDashboard: boolean = false;
        sandbox: Sandbox;
        processQueue : Array<SandboxProcessQueue>;
        meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        meevoSecurityPatrs = Meevo.Components.Common.SecurityParts;
        isSingleLocation: boolean = false;
       
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.modal.ModalService",
            "$rootScope",
            "$state", 
            "meevo.plugins.sandbox.SandboxService",
            "meevo.components.busy.BusyService",
            "meevo.components.common.IdentityService",
        ];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: any,
            public sandboxService: Meevo.Plugins.Sandbox.SandboxService,
            private busyService: Meevo.Components.Busy.IBusyService,
            protected identityService: Meevo.Components.Common.IIdentityService
        ) {
            this.busyService.start();
            this.getSenbox().finally(() => {
                this.busyService.stop();
            });
            this.isSingleLocation = this.identityService["identity"].isSingleLocation;
        }
    
        getSenbox(): ng.IPromise<any> {
            return this.sandboxService.sandboxExist().then((result: boolean) => {
                if (!result) return; 
                
                return this.sandboxService.getSandbox().then((result: Sandbox) => {
                    if (!result || !result.id) return;  

                    let dateNow = moment();
                    let updatedDate = moment(result.expirationDate);

                    result.daysRemainig = updatedDate.diff(dateNow, 'days');
                    this.sandbox = result;
                    this.showDashboard = true;

                    this.sandboxService.getProcessQueue().then((data: Array<SandboxProcessQueue>) => {
                        this.processQueue = data;
                    });
                }); 
            });
        }

        createSandbox(): void {
            this.busyService.start();
            this.sandboxService.createSandbox().then(() => {
                return this.getSenbox();
            }).finally(() => {
                this.busyService.stop();
            });
        }

        refreshSandbox(): void {
            this.busyService.start();
            this.sandboxService.refreshSandbox().then((result: SandboxProcessQueue) => {
                this.processQueue.push(result);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        cancelRefresh(processQueue: SandboxProcessQueue): void {
            this.modalService.confirm("MESSAGE_SANDBOX_CANCEL_REQUEST", ModalTranslationModes.Translate).then(() => {
                this.busyService.start();
                this.sandboxService.cancelRefreshSandbox(processQueue).then((data: SandboxProcessQueue) => {
                    processQueue.dateUpdated = data.dateUpdated;
                    processQueue.processType = data.processType;
                    processQueue.sandboxRequestStatus = data.sandboxRequestStatus;
                }).finally(() => {
                    this.busyService.stop();
                });                
            });
        }

        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
        }

        get processTypeEnum(): any {
            return ProcessTypeEnum;
        }

        get sandboxRequestStatusEnum(): any {
            return SandboxRequestStatusEnum;
        }

        get sandboxStatusEnum(): any {
            return SandboxStatusEnum;
        }
    }

    angular.module("meevo.plugins.sandbox")
        .controller("meevo.plugins.sandbox.SandboxController", SandboxController);
}